import entities from '../../../../config/Entities'
import { HALApiService } from '../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'

export const deliveryServicesRequestService = new CachedService(entities.Orderadmin_DeliveryServices_Entity_Service_DeliveryRequestService, '/delivery-services/delivery-requests-service', HALApiService, createItemsData)
